import { useTranslation } from 'react-i18next';

import { TtsLocale } from '../../../../models/Base';
import {
  getQuickCreateGameModeProps,
  QuickCreateGameMode,
} from '../../../../models/DraftStore';
import { WebBoosterType } from '../../../../models/UserStore';
import { AppBar } from '../../../Molecules';

import styles from './CreateMemoryGameProcessedContentExampleTemplate.module.css';

interface CreateMemoryGameProcessedContentExampleTemplateProps {
  type: QuickCreateGameMode | undefined;
  webBoosterType: WebBoosterType | undefined;
  selectedLanguage: TtsLocale;
  gameContents: string[];
  onClickBack: () => void;
}

export const CreateMemoryGameProcessedContentExampleTemplate = (
  props: CreateMemoryGameProcessedContentExampleTemplateProps,
) => {
  const { type, webBoosterType, selectedLanguage, gameContents, onClickBack } =
    props;
  const { t } = useTranslation();

  return (
    <div className={styles.createMemoryProcessContentExample}>
      <AppBar
        title={
          type ? t(getQuickCreateGameModeProps(type, webBoosterType).name) : ''
        }
        onClickBack={onClickBack}
      />
      <div className={styles.container}>
        <div className={styles.titleContainer}>
          {/* <p className={styles.gameTypeName}>
            {t(getQuickCreateGameModeProps(type).name)}
          </p> */}
          <p className={styles.gameTypeName}>
            {t('Original Content · Examples')}
          </p>
          <p className={styles.orangeDescription}>
            {t(
              'Each {type} is limited to {wordCount} words and {lineCount} line breaks. When your source content is too long, it will be divided into multiple practices.',
              {
                type: t(
                  type
                    ? getQuickCreateGameModeProps(type, webBoosterType).name
                    : '',
                ),
                wordCount: type
                  ? getQuickCreateGameModeProps(type, webBoosterType)
                      .splitLimitation
                  : 0,
                lineCount: 5,
              },
            )}
          </p>
        </div>

        {/* <div className={styles.cellHeader}>
          <p className={styles.title}>{t('Learning Content')}</p>
        </div> */}

        {gameContents.map((gamecontent, index) => (
          <div key={index} className={styles.gameCard}>
            <div className={styles.gameFooter}>
              <div className={styles.gameNumber}>{index + 1}</div>
            </div>
            <div className={styles.gameHeader}>
              <div className={styles.cardContent}>
                {t(gamecontent, { lng: selectedLanguage })}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
